import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { Preferences } from "@capacitor/preferences";

const CACHE_KEY = "emergency_places";
const VERSION_KEY = "emergency_places_version";

export const usePlacesData = () => {
  const [places, setPlaces] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1. Load cached data immediately so UI isn't empty
        const cachedRaw = await Preferences.get({ key: CACHE_KEY });
        const cachedVersion = await Preferences.get({ key: VERSION_KEY });

        if (cachedRaw.value) {
          setPlaces(JSON.parse(cachedRaw.value));
          setLoading(false); // show cached data right away
        }

        // 2. Check Firestore for latest version
        const docRef = doc(db, "emergency_data", "config");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          const remoteVersion = data.version;
          const localVersion = cachedVersion.value
            ? parseInt(cachedVersion.value)
            : -1;

          // 3. Only update cache if version changed
          if (remoteVersion !== localVersion) {
            setPlaces(data.places);
            await Preferences.set({
              key: CACHE_KEY,
              value: JSON.stringify(data.places),
            });
            await Preferences.set({
              key: VERSION_KEY,
              value: String(remoteVersion),
            });
          }
        }
      } catch (err) {
        console.warn("Failed to fetch from Firestore:", err);
        // silently fall back to cached data — already set above
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { places, loading };
};